import { PageStatus } from "@/stores/provider";
import { eventBus } from "./eventBus";
import { errorToast } from "./toast";

// 获取请求参数
export const getUrlQuery = (): URLSearchParams => {
  const query = new URLSearchParams(window.location.search);
  return query;
};

// 日期格式化
export const formatDate = (date: Date = new Date(), format = 'YYYY-MM-DD HH:mm:ss') => {
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
};
export const getWeekday = () => {
  const currentDate = new Date();
  const weekdayIndex = currentDate.getDay();
  const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  const weekday = weekdays[weekdayIndex];
  return weekday;
};

export const temporaryLogin = () => {
  const a = sessionStorage.getItem('videoAudit-b-temporaryLogin');
  if (a) {
    return true;
  }
  const query = getUrlQuery();
  const v = query.get(process.env.LOGIN_KEY!);
  if (v === process.env.LOGIN_VALUE) {
    sessionStorage.setItem('videoAudit-b-temporaryLogin', '1');
    return true;
  }
  return false;
};

export const clearLoginMes = (mes?: string) => {
  eventBus.emit('eventBusDispatch', {
    pageStatus: PageStatus.NOLOGIN,
    userInfo: {},
  });
  sessionStorage.removeItem('videoAudit-b-token');
  sessionStorage.removeItem('videoAudit-b-pageStatus');
  sessionStorage.removeItem('videoAudit-b-temporaryLogin')
  errorToast(mes || '登录已过期，请重新登录');
};

export const pageSpy = () => {
  const isDev = process.env.NODE_ENV === 'development';
  if (!isDev || window.location.hostname === 'localhost') return;
  const loadScript = (src: string) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('crossorigin', 'anonymous');

      script.onload = () => resolve(src);
      script.onerror = () => reject(new Error(`Script load error: ${src}`));

      document.body.appendChild(script);
    });
  }
  Promise.all([
    loadScript('https://pagespy.k8s.hy-sams.vip/page-spy/index.min.js'),
    loadScript('https://pagespy.k8s.hy-sams.vip/plugin/data-harbor/index.min.js'),
    loadScript('https://pagespy.k8s.hy-sams.vip/plugin/rrweb/index.min.js')
  ]).then((loadedScripts) => {
    console.log('所有脚本加载完成:', loadedScripts);
    const script = document.createElement('script');
    script.textContent = `
      window.$harbor = new DataHarborPlugin();
      window.$rrweb = new RRWebPlugin();
      [window.$harbor, window.$rrweb].forEach((p) => {
        PageSpy.registerPlugin(p);
      });

      // 实例化的参数都是可选的
      window.$pageSpy = new PageSpy({
        api: "pagespy.k8s.hy-sams.vip",
        clientOrigin: "https://pagespy.k8s.hy-sams.vip",
        project: "React 演示",
        autoRender: true,
        title: "PageSpy 🤝 React",
      });
    `;
    document.body.appendChild(script);
  }).catch((error) => {
    console.error('至少一个脚本加载失败:', error);
  });
};